export default {"src":"/_next/static/media/fieo.4f9e6f60.svg","height":159,"width":156};